export const NCUI_MODAL_PREFIX = 'ncuim-';
const NCUI_TOAST_PREFIX = `${NCUI_MODAL_PREFIX}toast`;

export const modalClass = {
    BACKDROP: `${NCUI_MODAL_PREFIX}backdrop`,
    BACKDROP_SHOW: `${NCUI_MODAL_PREFIX}backdrop-show`,
    BACKDROP_HIDE: `${NCUI_MODAL_PREFIX}backdrop-hide`,
    CONTAINER: `${NCUI_MODAL_PREFIX}container`,
    BUTTON_CANCEL: `${NCUI_MODAL_PREFIX}button__cancel`,
    BUTTON_CONFIRM: `${NCUI_MODAL_PREFIX}button__confirm`,
    BUTTON_CLOSE: `${NCUI_MODAL_PREFIX}close`,
} as const;

export const toastClass = {
    TOAST: NCUI_TOAST_PREFIX,
    TOAST_TYPE_VERTICAL: 'vertical',
    TOAST_TYPE_HORIZONTAL: 'horizontal',
    TOAST_SHOW: `${NCUI_TOAST_PREFIX}-show`,
    TOAST_HIDE: `${NCUI_TOAST_PREFIX}-hide`,
} as const;

export const popupClass = {
    POPUP: `${NCUI_MODAL_PREFIX}modal`,
    POPUP_SHOW: `${NCUI_MODAL_PREFIX}shown`,
    POPUP_CONTAINER_SHOW: `${modalClass.CONTAINER}-show`,
    POPUP_CONTAINER_HIDE: `${modalClass.CONTAINER}-hide`,
} as const;
